import moment from 'moment/moment';

export const formatToUTC = (date) => {
  return moment.utc(moment(date)).format();
};

export const formatDateWithTime = (date, isShortYear) => {
  return moment(date).format(`DD.MM.${isShortYear ? 'YY' : 'YYYY'} HH:mm`);
};
